import Navbar from "@/components/navbar/Navbar";
import Footer from "@/components/footer/Footer";
import AnalyticsClicks from "@/components/analytics/AnalyticsClicks";
import WhatsAppFloatingButton from "@/components/ui/chatFormWhatsapp";
import CursorGlow from "./CursorGlow";
import MotionProvider from "./MotionProvider";

interface PageShellProps {
  children: React.ReactNode;
  navbar?: "overlay" | "flow";
}

/**
 * Moldura do tema escuro Alert AI: navbar + conteúdo + footer,
 * cursor glow, medição de cliques e o chat de suporte via WhatsApp.
 */
export default function PageShell({ children, navbar = "overlay" }: PageShellProps) {
  return (
    <MotionProvider>
      <div className="alert-shell">
        <a
          href="#conteudo"
          className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-full focus:bg-brand focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:text-white"
        >
          Ir para o conteúdo
        </a>
        <CursorGlow />
        <AnalyticsClicks />
        <Navbar variant={navbar} />
        <main id="conteudo">{children}</main>
        <Footer />
        <WhatsAppFloatingButton />
      </div>
    </MotionProvider>
  );
}
